module.exports = __webpack_public_path__ + "static/media/World.214cb7ce.svg";